<template>
  <div class="box-container">
    <div class="box__content-container">
      <div
        v-for="(box, i) in count"
        :key="`box-${i}`"
        class="box"
        :class="[`background-${bgColor}`, `box-${bgColor}`]"
      ></div>
    </div>
    <div class="box__title" :class="{ 'box__title--show': showTitle }">
      <slot />
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
export default {
  props: {
    count: {
      type: Number,
    },
    bgColor: {
      type: String,
    },
  },
  data() {
    return {
      showTitle: false,
    };
  },
  mounted() {
    gsap.set(`.box-${this.bgColor}`, { autoAlpha: 0 });
    let targets = gsap.utils.toArray(`.box-${this.bgColor}`);
    targets.forEach((item, i) => {
      gsap.to(item, {
        autoAlpha: 1,
        delay: i * 0.01,
        onComplete: () => (this.showTitle = true),
      });
    });
  },
};
</script>

<style scoped>
.box-container {
  display: flex;
}
.box__content-container {
  display: flex;
  width: 80%;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.box {
  width: 10px;
  height: 10px;
  flex: 0 0 10px;
  margin: 1px;
}
.box__title {
  opacity: 0;
  transition: all 0.3s ease;
}
.box__title--show {
  opacity: 1;
}
@media screen and (max-width: 1024px) {
  .box {
    width: 5px;
    height: 5px;
    flex: 0 0 5px;
    margin: 0.5px;
  }
}
</style>
